import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import { PortfolioPage } from "@/components/ui/starfall-portfolio-landing";
import { API_BASE } from "@/lib/api";
import {
  getFallbackProjects,
  getPortfolioCategories,
  getPortfolioChromeContent,
  mapCaseStudiesToProjects,
  type PortfolioCaseStudy,
} from "@/lib/portfolio-content";

const API = API_BASE;

const Portfolio = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language === "es" ? "es" : "en";
  const [cases, setCases] = useState<PortfolioCaseStudy[]>([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    axios
      .get<PortfolioCaseStudy[]>(`${API}/cases`)
      .then((response) => {
        if (!cancelled) {
          setCases(Array.isArray(response.data) ? response.data : []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCases([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const categories = getPortfolioCategories(locale);
  const getCategoryLabel = (category: string) =>
    categories.find((item) => item.key === category)?.title?.toString() || category.replace(/_/g, " ");

  const mappedProjects = mapCaseStudiesToProjects(cases, locale, getCategoryLabel);
  const hydratedProjects = mappedProjects.length > 0 ? mappedProjects : getFallbackProjects(locale, getCategoryLabel);
  const visibleProjects =
    activeCategory === "all"
      ? hydratedProjects
      : hydratedProjects.filter((project) => project.category === activeCategory);
  const chromeContent = getPortfolioChromeContent(locale);
  const emptyMessage =
    locale === "es"
      ? "Todavia no hay casos publicados en esta categoria. Podemos seguir usando esta estructura y sumar contenido desde el admin cuando este listo."
      : "There are no published case studies in this category yet. The page structure is ready for more content as the admin library grows.";

  return (
    <>
      <Navbar />
      <PortfolioPage
        {...chromeContent}
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
        projects={visibleProjects}
        loading={loading}
        emptyMessage={emptyMessage}
      />
      <Footer />
    </>
  );
};

export default Portfolio;
